import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { makeStyles } from '@mui/styles'
import { Grid, Stack, Theme } from '@mui/material'

import {
  PostingTemplate, ScreenEnum, ViewEnum,
} from '@professocial/professocialTypes/types/commonTypes'

import { IInstagramPostProps } from './InstagramPostTemplate'
import PostContentPreview from '../../../shared/components/ModuleComponents/Preview/modules/shared/PostContentPreview'
import InstaProfileImage from '../../../shared/components/ModuleComponents/Preview/modules/instagram/InstaProfileImage'
import InstaHeadline from '../../../shared/components/ModuleComponents/Preview/modules/instagram/InstaHeadline'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { PostingConfiguration } from '@professocial/professocialTypes'
import { getPostingConfiguration } from '../../../store/common/common.selectors'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: '40px 20px',
  },
}))

const InstagramPreview: React.FC<IInstagramPostProps> = (props: IInstagramPostProps) => {
  const postingConfiguration: PostingConfiguration | undefined = useSelector(getPostingConfiguration)

  const view = props.view || ViewEnum.overview
  const size = props.size || ScreenEnum.xl

  const [post, setPost] = useState<PostingTemplate>(props.post as PostingTemplate)

  const networkType: NetworkType = props.networkType || NetworkType.Facebook
  const { instagramPage } = postingConfiguration?.networkPage || {}

  useEffect(() => {
    setPost(props.post as PostingTemplate)
  }, [props.post])

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Stack direction='row'>
            <InstaProfileImage
              data={props.networkPageId ? `https://graph.facebook.com/${props.networkPageId}/picture` : 'noimage'}
              view={props.view}
            />
            <InstaHeadline
              networkPageId={props.networkPageId}
              post={post}
              networkType={networkType}
              value={instagramPage && instagramPage.networkUserName}
              view={view}
              size={size}
            />
          </Stack>
        </Grid>
        <Grid xs={12} item>
          <PostContentPreview
            networkPageId={props.networkPageId}
            post={post}
            networkType={networkType}
            value={post}
            view={view}
            size={size}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default InstagramPreview
